import { notification } from 'antd';
import actions from './actions';
import { QUERY } from './query';
import { DataService } from '../../config/dataService/dataService';

const addNotificationSuccess = () => {
  notification.success({
    message: 'Job Description Added Successfully!',
  });
};

const addNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const deleteNotificationSuccess = () => {
  notification.success({
    message: 'Job Description has been Deleted',
  });
};

const deleteNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const updateNotificationSuccess = () => {
  notification.success({
    message: 'Job Description has been updated',
  });
};

const updateNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const {
  AddJDBegin,
  AddJDSuccess,
  AddJDErr,

  ReadJDBegin,
  ReadJDSuccess,
  ReadJDErr,

  UpdateJDBegin,
  UpdateJDSuccess,
  UpdateJDErr,

  DeleteJDBegin,
  DeleteJDSuccess,
  DeleteJDErr,
} = actions;

const DataSubmit = (data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(AddJDBegin());
      const response = await DataService.gql(QUERY.addMasterDescriptions(data));
      const token = localStorage.getItem('access_token');
      if (token) {
        await dispatch(AddJDSuccess(response.data.data));
        addNotificationSuccess();
        callback(true);
      } else {
        await dispatch(AddJDErr('No Unauthorize access'));
        addNotificationError('No Unauthorize access');
      }
    } catch (err) {
      await dispatch(AddJDErr('Something went wrong, Unable to create company.'));
      addNotificationError('Something went wrong, Unable to create company.');
    }
  };
};

const DataRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(ReadJDBegin());
      const query = await DataService.gql(QUERY.allMasterDescriptions);
      const token = localStorage.getItem('access_token');
      if (token) {
        await dispatch(ReadJDSuccess(query.data.data.allMasterDescriptions.nodes));
      } else {
        await dispatch(AddJDErr('No Unauthorize access'));
        addNotificationError('No Unauthorize access');
      }
    } catch (err) {
      await dispatch(ReadJDErr(err));
    }
  };
};

const DataSearch = (searchItem) => {
  return async (dispatch) => {
    try {
      await dispatch(ReadJDBegin());
      if (searchItem !== '') {
        const query = await DataService.get(`/data/search/${searchItem}`);
        await dispatch(ReadJDSuccess(query.data.data));
      } else {
        try {
          const query = await DataService.get('/data/all');
          await dispatch(ReadJDSuccess(query.data.data));
        } catch (err) {
          await dispatch(ReadJDErr(err));
        }
      }
    } catch (err) {
      await dispatch(ReadJDErr(err));
    }
  };
};

const DataUpdate = (id, data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(UpdateJDBegin());
      await DataService.gql(QUERY.updateMasterDescriptions({ id, ...data }));
      await dispatch(UpdateJDSuccess());
      updateNotificationSuccess();
      callback(true);
    } catch (err) {
      await dispatch(UpdateJDErr(err));
      updateNotificationError(err);
    }
  };
};

const DataDelete = ({ id, getData }) => {
  return async (dispatch) => {
    try {
      await dispatch(DeleteJDBegin());
      const data = await DataService.gql(QUERY.updateMasterDescriptions({ id, isActive: false }));

      await dispatch(DeleteJDSuccess(data.data));
      await getData();
      deleteNotificationSuccess();
    } catch (err) {
      await dispatch(DeleteJDErr(err));
      deleteNotificationError(err);
    }
  };
};

export { DataRead, DataSearch, DataSubmit, DataDelete, DataUpdate };
